import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxIndexedDB } from 'ngx-indexed-db';
(window as any).global = window;
import * as SecureLS from 'secure-ls'

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  ls = new SecureLS({
    encodingType: 'des',
    isCompression: false,
    encryptionSecret: 'cstem-secret'
  });

  constructor(private myRoute: Router) {
    // this.ls.set('key1', 'mohana'); // set key1
    // this.ls.get('key1'); // print data
    // console.log(this.ls.get('key1'))
  }

  saveUserId(userid) {
    // this.add({ UserId: userid })
    this.ls.set('key1', userid);
    // localStorage.setItem("UserId", userid)
  }

  getUserId() {
    // this.getdata();
    return parseInt(this.ls.get('key1'));
    // return parseInt(localStorage.getItem("UserId"));
  }

  saveGuestUserId(userid) {
    // this.add({ GuestId: userid })
    this.ls.set('key2', userid);
    // localStorage.setItem("key2", userid)
  }

  getGuestUserId() {
    // return localStorage.getItem("key2");
    return this.ls.get('key2')
  }

  saveUserInfo(user) {
    // this.add({ LoggedInUser1: JSON.stringify(user) })
    // localStorage.setItem("key3", JSON.stringify(user))
    this.ls.set('key3', user);
    // localStorage.setItem("key3", user)
  }

  getUserInfo() {
    // return JSON.parse(localStorage.getItem("key3"))
    return this.ls.get('key3')
  }

  saveOptions(opt) {
    // localStorage.setItem("options", JSON.stringify(opt))
    this.ls.set('key4', opt);
  }

  getOptions() {
    // return JSON.parse(localStorage.getItem("options"))
    return this.ls.get('key4')
  }

  saveUserLocation(loc) {
    this.ls.set('key5', loc);
    // localStorage.setItem("UserLocation", JSON.stringify(loc))
  }

  getUserLocation() {
    // return JSON.parse(localStorage.getItem("UserLocation"))
    return this.ls.get('key5')
  }

  savePlantId(id) {
    this.ls.set('key6', id);
    // localStorage.setItem("plantId", JSON.stringify(id))
  }

  getPlantId() {
    return parseInt(this.ls.get('key6'))
    // return parseInt(localStorage.getItem("plantId"));
  }

  isLoggednIn() {
    return this.getUserInfo() !== '';
  }

  saveAlbidoId(id) {
    this.ls.set('key7', id);
    // localStorage.setItem("albido", id)
  }

  getAlbidoId() {
    return parseInt(this.ls.get('key7'))
    // return parseInt(localStorage.getItem("albido"));
  }

  // saveInputSummary(inp) {
  //   localStorage.setItem('inputsummary', JSON.stringify(inp))
  // }

  // getInputSummary() {
  //   return JSON.parse(localStorage.getItem('inputsummary'));
  // }

  saveAppCode(inp) {
    this.ls.set('key8', inp);
    // localStorage.setItem("appcode", inp)
  }

  getAppCode() {
    return this.ls.get('key8')
    // return localStorage.getItem('appcode');
  }

  saveCaseDetails(details) {
    this.ls.set('key9', details);
    // localStorage.setItem('casedetails', JSON.stringify(details))
  }

  getCaseDetails() {
    return this.ls.get('key9')
    // return JSON.parse(localStorage.getItem('casedetails'));
  }

  setIsGuest(key) {
    this.ls.set('key10', key);
  }

  getIsGuest() {
    return this.ls.get('key10')
  }

  setIsDemo(key) {
    this.ls.set('key11', key);
  }

  getIsDemo() {
    return this.ls.get('key11')
  }

  saveDailyLoad(load) {
    this.ls.set('key15', load);
  }

  getDailyLoad() {
    return this.ls.get('key15');
  }

  savePlantSummaryReport(report) {
    this.ls.set('key16', report);
  }

  getPlantSummaryReport() {
    return this.ls.get('key16');
  }

  logout() {
    // console.log(this.ls.getAllKeys())
    // this.ls.removeAll();
    // this.ls.clear();

    this.ls.remove('key1');
    this.ls.remove('key2');
    this.ls.remove('key3');
    this.ls.remove('key4');
    this.ls.remove('key5');
    this.ls.remove('key6');
    this.ls.remove('key7');
    this.ls.remove('key8');
    this.ls.remove('key9');
    this.ls.remove('key10');
    this.ls.remove('key11');
    this.ls.remove('key12');
    this.ls.remove('key13');
    this.ls.remove('key14');
    this.ls.remove('key15');
    this.ls.remove('key16');

    // localStorage.removeItem("UserId");
    // localStorage.removeItem("LoggedInUser1");
    // localStorage.removeItem("GuestId");
    // localStorage.removeItem("options");
    // localStorage.removeItem("UserLocation");
    // localStorage.removeItem("plantId");
    // localStorage.removeItem("albido");
    // localStorage.removeItem("inputsummary");
    // localStorage.removeItem("appcode");
    // localStorage.removeItem("casedetails");
    // localStorage.removeItem('isG')
    // localStorage.removeItem('isD')
    this.myRoute.navigate([""]);
  }
}
